import React, { useState, useRef, useEffect } from "react";
import { MessageCircle, X, Send } from "lucide-react";
import { api } from "@/lib/apiClient";

export const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content:
        "Ciao! Sono Marco di MC Studio 👋 Aiuto aziende e professionisti a farsi un sito internet fatto bene. Vuoi vedere com'è il tuo, gratis? Dimmi pure!",
    },
  ]);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, open]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    const newMessages = [...messages, { role: "user", content: text }];
    setMessages(newMessages);
    setInput("");
    setLoading(true);
    try {
      const { data } = await api.post("/chat", {
        message: text,
        session_id: sessionId,
        history: messages,
      });
      setSessionId(data.session_id);
      setMessages([...newMessages, { role: "assistant", content: data.reply }]);
    } catch (e) {
      setMessages([
        ...newMessages,
        {
          role: "assistant",
          content:
            "Mi scuso, c'è stato un problema. Scrivici su WhatsApp al +39 375 9920268!",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        data-testid="chatbot-toggle"
        className="fixed bottom-24 right-6 z-[9998] bg-coral text-white rounded-full p-4 shadow-lg hover:bg-[#e04047] hover:shadow-xl transition-all duration-300"
        aria-label="Apri chat"
      >
        {open ? <X size={26} /> : <MessageCircle size={26} />}
      </button>

      {open && (
        <div
          className="fixed bottom-44 right-6 z-[9998] w-[calc(100vw-3rem)] sm:w-96 h-[520px] bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden border border-ink/10 animate-fade-up"
          data-testid="chatbot-window"
        >
          <div className="bg-ink text-beige px-5 py-4 flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-coral flex items-center justify-center font-bold text-white">
              M
            </div>
            <div>
              <p className="font-semibold leading-tight">Marco · MC Studio</p>
              <p className="text-xs text-beige/60">Assistente virtuale · online</p>
            </div>
          </div>

          <div
            ref={scrollRef}
            className="flex-1 overflow-y-auto p-4 space-y-3 bg-beige/40"
            data-testid="chatbot-messages"
          >
            {messages.map((m, i) => (
              <div
                key={i}
                className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}
              >
                <div
                  className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${
                    m.role === "user"
                      ? "bg-coral text-white rounded-br-sm"
                      : "bg-white text-ink border border-ink/10 rounded-bl-sm"
                  }`}
                >
                  {m.content}
                </div>
              </div>
            ))}
            {loading && (
              <div className="flex justify-start">
                <div className="bg-white border border-ink/10 rounded-2xl px-4 py-3 flex gap-1">
                  <span className="h-2 w-2 bg-ink/40 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                  <span className="h-2 w-2 bg-ink/40 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                  <span className="h-2 w-2 bg-ink/40 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
                </div>
              </div>
            )}
          </div>

          <div className="p-3 border-t border-ink/10 bg-white flex gap-2">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Scrivi un messaggio..."
              data-testid="chatbot-input"
              className="flex-1 bg-beige/60 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-coral/40"
            />
            <button
              onClick={send}
              disabled={loading}
              data-testid="chatbot-send"
              className="bg-coral text-white rounded-full p-2.5 hover:bg-[#e04047] transition-colors disabled:opacity-50"
            >
              <Send size={18} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
